<script>
    import { onMount, beforeUpdate, afterUpdate } from 'svelte';

    import * as FilePond from 'filepond';
    import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
    import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
    import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
    import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
    import FilePondPluginFileRename from 'filepond-plugin-file-rename';
    import FilePondPluginFileEncode from 'filepond-plugin-file-encode';
    import FilePondPluginImageResize from 'filepond-plugin-image-resize';
    import FilePondPluginImageTransform from 'filepond-plugin-image-transform';

    import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
    import 'filepond/dist/filepond.min.css';

    import dayjs from 'dayjs'
    // import advancedFormat from 'dayjs/plugin/advancedFormat'
    // import localeData from 'dayjs/plugin/localeData'
    // dayjs.extend(advancedFormat)
    // dayjs.extend(localeData)

    export let pond = null, filename = '', id, key, initFileName = ''
    export let
        acceptmediatype = [],
        allowFileRename = true,
        allowMultiple = false,
        maxFiles = 1,
        labelIdle,
        update = false,
        files = []

    FilePond.registerPlugin(
        // FilePondPluginImageExifOrientation,
        FilePondPluginImagePreview,
        // FilePondPluginFileValidateSize,
        FilePondPluginFileValidateType,
        FilePondPluginFileRename,
        FilePondPluginFileEncode,
        FilePondPluginImageResize,
        FilePondPluginImageTransform
    );

    onMount(() => {

        pond = FilePond.create(document.getElementById(id), {
            allowImageResize: true,
            imageResizeUpscale: false,
            imageResizeTargetWidth: '600',
            allowFileEncode: true,
            allowMultiple: allowMultiple,
            maxFiles: maxFiles,
            allowFileRename: allowFileRename,
            fileRenameFunction: (file) => {
                filename = picname_sanitizer(file.name)
                return filename
                // return update ? file.name : `${file.name.split('.')[0]}_${Date.now()}${file.extension}`;
            },
            labelIdle: labelIdle,
            acceptedFileTypes: acceptmediatype,
            onpreparefile: (fileItem, output) => {
                // console.log('@prep ', output)
                files = [...files, output]
            },
            // onupdatefiles: fileItems => {
            //     // console.log('@update ',fileItems)
            // },
            credits: false
        });

        if (initFileName != '')
            pond.addFile(initFileName);
    }) 

    let picname_sanitizer = str => {
        let namearr = str.split('.'), ext = namearr[namearr.length - 1],
            sanitized = namearr.filter(n => n !== ext).join('').replace(/[^A-Za-z0-9-.]|\s/gi, '_');
        return `${sanitized}_${dayjs().unix()}.${ext}`;
    }

</script>

<div id="fpcontainer{key}">
    <input {id} type="file" class="filepond" data-allow-reorder="true" data-max-file-size="3MB"
        style="display: none;" />
</div>
<!-- accept="{acceptmediatype}"  -->